export default __webpack_public_path__ + "static/media/img_6.f40365c4.JPG";